import { render } from "./StartAssessment.vue?vue&type=template&id=ee6ce80c"
import script from "./StartAssessment.vue?vue&type=script&lang=js"
export * from "./StartAssessment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__